import { Injectable } from '@angular/core';
import { AppSettings } from '../shared/App-Settings';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthenticationService } from '../core/authentication.service';
import { Observable, of, Subject } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { ResponseDTO } from '../models/response-dto';
import { Overpacks } from '../models/overpacks';
import { Overpackfilteroption } from '../searchFilters/overpackfilteroption';
import { DatePipe } from '@angular/common';

const apiUrl = AppSettings.API_BASE_URL + "api/";

@Injectable({
  providedIn: 'root'
})
export class OverpackServices {

  isUpdate: boolean = false;
  isUpdateSubject: Subject<boolean> = new Subject<boolean>();
  isUpdateObs = this.isUpdateSubject.asObservable();
  isAddedSubject: Subject<boolean> = new Subject<boolean>();
  isAddedObs = this.isAddedSubject.asObservable();


  constructor(private httpClient: HttpClient, private auth: AuthenticationService) {

  }

  private handleError<T>(operation = 'operation', result?: T) {
    let errorMsg = '';
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  getOverpacks(currentPage: number, pageSize: number, order: string, sortby: string, overpackFilter: Overpackfilteroption): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}` + 'OverpacksCollection';

    url = url + '?PageNo=' + currentPage + '&PageSize=' + pageSize + '&Sort=' + sortby + " " + order;

    if (overpackFilter.overpackCode) {
      url = url + '&overpackCode=' + btoa(overpackFilter.overpackCode);
    }
    if (overpackFilter.status) {
      url = url + '&status=' + overpackFilter.status;
    }

    if (overpackFilter.shipmentId) {
      url = url + '&shipmentId=' + overpackFilter.shipmentId;
    }
    if (overpackFilter.shipmentCode) {
      url = url + '&shipmentCode=' + overpackFilter.shipmentCode;
    }

    if (overpackFilter.countryName) {
      url = url + '&countryName=' + overpackFilter.countryName;
    }

    if (overpackFilter.searchKey) {
      url = url + '&searchKey=' + overpackFilter.searchKey;
    }

    if (overpackFilter.excludeStatus) {
      url = url + '&excludeStatus=' + overpackFilter.excludeStatus;
    }

    if (overpackFilter.countryId) {
      url = url + '&countryId=' + overpackFilter.countryId;
    }

    if (overpackFilter.shipmentDate) {
      var pipe = new DatePipe('en-US');
      url = url + '&shipmentDate=' + pipe.transform(overpackFilter.shipmentDate, "MM-dd-yyyy");
    }
    url = url + '&showAll=' + true;

    return this.httpClient.get<any>(url, httpOptions);
  }
  getOverpacksByFranchiseId(currentPage: number, pageSize: number, order: string, sortby: string, countryId: number, status: string, searchKey: string): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}` + 'OverpacksCollection';

    url = url + '?PageNo=' + currentPage + '&PageSize=' + pageSize + '&Sort=' + sortby + " " + order;

    if (countryId > 0) {
      url = url + '&countryId=' + countryId;
    }
    if (status) {
      url = url + '&status=' + status;
    }

    if (searchKey) {
      url = url + '&searchKey=' + searchKey;
    }

    url = url + '&showAll=' + true;

    return this.httpClient.get<any>(url, httpOptions).pipe(
      tap(heroes => console.log('fetched products')),
      catchError(this.handleError('getPackages', []))
    );
  }


  AddOverpack(Overpack): Observable<Overpacks> {

    let accessToken = this.auth.getAccessToken();

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}` + 'overpacks';
    return this.httpClient.post<Overpacks>(url, Overpack, httpOptions);
  }

  getOverpackById(id: number): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    const url = `${apiUrl}` + "overpacks/" + `${id}`;

    return this.httpClient.get<any>(url, httpOptions);
  }

  UpdateOverpack(id, overpack): Observable<Overpacks> {

    // overpack.closingTime = overpack.shipmentCloasingTime.toLocaleString();
    // overpack.shipmentDate = overpack.shipmentDate.toLocaleString();


    if (overpack.closingTime)
      overpack.closingTime = overpack.shipmentCloasingTime.toLocaleString();

    if (overpack.shipmentDate)
      overpack.shipmentDate = overpack.shipmentDate.toLocaleString();


    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}` + 'overpacks/' + `${id}`;
    return this.httpClient.put<Overpacks>(url, overpack, httpOptions);
  }

  deleteOverpack(OverpackId: number) {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}` + 'overpacks/' + OverpackId;

    return this.httpClient.delete<any>(url, httpOptions);
  }

  updateOverPackStatus(overPackId: number, status: number) {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };

    let url = `${apiUrl}overpacks/${overPackId}/updateOverpackstatus/${status}`;

    return this.httpClient.put<any>(url, {}, httpOptions);
  }

}

